import * as yup from "yup";
import { countriesWithRequiredRegion } from "~/utils/utils";

export const invoiceTemplateValidator = yup.object().shape({
  label: yup.string(),
  company_name: yup.string().required(),
});

export const invoiceTemplateDetailsValidator = (taxNumberRequired) => {
  return yup.object().shape({
    address_line_1: yup.string().trim().required(),
    address_line_2: yup.string().trim(),
    city: yup.string().trim().required(),
    zip_code: yup.string().trim().required(),
    region: yup
      .string()
      .trim()
      .when("country", {
        is: (value) => {
          return countriesWithRequiredRegion.includes(value);
        },
        then: yup.string().trim().required(),
        otherwise: yup.string().trim(),
      }),
    country: yup.string().trim().required(),
    tax_number: taxNumberRequired ? yup.string().trim().required() : yup.string().trim(),
  });
};
